import * as THREE from 'three/build/three.min'
window.THREE = THREE
// require('three/examples/js/controls/TrackballControls')
// require('three/examples/js/controls/OrbitControls')
require('three/examples/js/controls/DeviceOrientationControls')
require('three/examples/js/modifiers/ExplodeModifier')
require('three/examples/js/modifiers/TessellateModifier')
// require('three/examples/js/modifiers/SubdivisionModifier')
// require('three/examples/js/modifiers/SimplifyModifier')
// require('three/examples/js/helpers/PointLightHelper')
require('./CustomOrbitControls')
require('./CustomTrackballControls')
export default THREE



// WEBPACK FOOTER //
// ./src/lib/three-extra.js